import { render, staticRenderFns } from "./AdminsManagment.vue?vue&type=template&id=64d57e2a&"
import script from "./AdminsManagment.vue?vue&type=script&lang=ts&"
export * from "./AdminsManagment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports